import {scriptonload} from '../modules/scriptonload';

var bcontentForm = function(form){
	var area = form.querySelector('[data-bcontentForm-area]'),
		box,
		bcontentObj,
		replaceArea = function(){
			var snippetFile = area.getAttribute('data-bcontentForm-area');
			//
			box = document.createElement('DIV');
			box.classList.add('columnForm_bcontent');
			box.classList.add('visualEditorInsertion');
			box.setAttribute('data-param', '{"snippetFile":"'+ snippetFile +'"}');
			box.innerHTML = area.value;
			area.parentNode.insertBefore(box, area);
		},
		addBcontent = function(){
			console.log(bcontent);
			bcontentObj = bcontent(box);
		},
		beforeSubmit = function(e){
			var html = bcontentObj.getHTML();
			area.value = html;
		},
		addEvents = function(){
			form.addEventListener('submit', beforeSubmit, false);
		},
		init = function(){
			replaceArea();
			addBcontent();
			addEvents();
		};

	scriptonload(APP.vendors.bcontent, function(){
			init();
		}
	);
}

export {bcontentForm};

